import { useRouter } from 'next/router';
import { APP_IMG, SHOW_COMMEMORATE } from 'src/constants';
import { WEB_TITLE } from 'src/constants/layout';
import { DATALAYER_TYPE, sendDataLayerGlobal } from 'src/services/member-auth/datalayer/send-datalayer';
const HeaderLogo = () => {
  const router = useRouter();
  return (
    <>
      <div className={`header-logo ${SHOW_COMMEMORATE === 'true' ? 'commemorate-mode' : ''}`}>
        <a
          href='/'
          img-fluid='true'
          title='logo'
          //! DATALAYER
          onClick={() =>
            sendDataLayerGlobal({
              type: DATALAYER_TYPE.TRACK_POSITION,
              router: router?.pathname,
              position: 'on:header',
              section: 'header',
              data: {
                title: 'logo',
                heading: 'logo'
              }
            })
          }
        >
          {
            router.asPath === '/' &&
            <h1>
              <span> {WEB_TITLE} </span>
            </h1>
          }

          {/* <img classNa me={SHOW_COMMEMORATE === 'true' ? 'ribbon' : ''} src={SHOW_COMMEMORATE === 'true' ? `${APP_IMG}/images/logo-header-ribbon-1.png` : `${APP_IMG}/images/logo-header.webp`} alt='logo-header' title={WEB_TITLE} width='100%' height='100%' /> */}
          <img
            style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.5)' : 'unset' }}
            className={SHOW_COMMEMORATE === 'true' ? 'ribbon' : 'default'}
            src={SHOW_COMMEMORATE === 'true' ? `${APP_IMG}/images/logo-header-ribbon-1.png` : `${APP_IMG}/images/logo-header.webp`}
            srcSet={
              SHOW_COMMEMORATE === 'true'
                ? `
              ${APP_IMG}/images/logo-header-ribbon-1.png 1x,
              ${APP_IMG}/images/logo-header-ribbon-1@2x.png 2x`
                : ` ${APP_IMG}/images/logo-header.webp 1x,
              ${APP_IMG}/images/logo-header.webp 2x`
            }
            alt='logo-header'
            title={WEB_TITLE}
            width={73}
            height={36}
          />
        </a>
      </div>
    </>
  );
};

export default HeaderLogo;
